import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../model/RootStoreContext';
import type { IKindVersion } from '../model/kind/KindVersion';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

export interface useSpecificationsForExperimentsResult {
    isLoaded: boolean;
    specificationKinds: IKindVersion[] | null;
}

export const useSpecificationsForExperiments = () => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState<useSpecificationsForExperimentsResult>({
        isLoaded: false,
        specificationKinds: []
    });

    useEffect(() => {
        setResult({ isLoaded: false, specificationKinds: [] });

        rootStore.specificationsForExperimentsStore.loadSpecifications()
            .then(() => {
                setResult({
                    isLoaded: true,
                    specificationKinds: rootStore.specificationsForExperimentsStore.getKinds()
                });
            })
            .catch(e => publishNotification({
                text: `Error loading specifications for experiments: ${e.message}`,
                canClose: true
            }));
    }, [rootStore.specificationsForExperimentsStore, publishNotification, rootStore.gameVersionStore.currentGameVersion]);

    return result;
};
